function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_28",
  "data-name": "Group 28"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_4",
  "data-name": "Ellipse 4",
  cx: 37.5,
  cy: 37.5,
  r: 37.5,
  transform: "translate(24.999)",
  fill: "#ce0e2d"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_30",
  "data-name": "Path 30",
  d: "M535.537,1233.086h104.02a10.491,10.491,0,0,0,10.489-10.489V1175.27a54.685,54.685,0,0,0-54.686-54.686H579.734a54.686,54.686,0,0,0-54.686,54.686V1222.6A10.491,10.491,0,0,0,535.537,1233.086Z",
  transform: "translate(-525.048 -1033.086)",
  fill: "#ce0e2d"
}));

function SvgAdultFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "adult-filled",
    width: 124.998,
    height: 200,
    viewBox: "0 0 124.998 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdultFilled);
export default __webpack_public_path__ + "static/media/adult-filled.f802af82.svg";
export { ForwardRef as ReactComponent };